<div #text id="text" class="text">
  La page que vous cherchez n'existe pas ou plus.
  Veuillez nous excuser pour la gène occasionnée.
  <br />
  <br />
  <a [routerLink]="['/']">Retour à l'accueil</a>
</div>
